import { init, createReduxEnhancer, withErrorBoundary, ErrorBoundary } from '@sentry/react';
import { ExtraErrorData } from '@sentry/integrations';

import config from 'config/config';
import env from 'constants/env';

const options = {
    dsn: 'https://45b9dc52cc074ed88c250f487a134de8@o481746.ingest.sentry.io/4505119892570112',
    debug: process.env.NODE_ENV === env.DEVELOPMENT,
    environment: process.env.NODE_ENV,
    release: config.app.slug,
    integrations: [new ExtraErrorData()],
};

if (!options.dsn) {
    const url = `https://sentry.io/ackee-internal/app4event-admin-production/getting-started/javascript-react/`;
    // eslint-disable-next-line no-console
    console.warn(`[Sentry]: Add 'dsn' of your project.\n${url}`);
}

export const initializeSentry = () => {
    const initCallback = () => init(options);

    window.requestIdleCallback ? window.requestIdleCallback(initCallback) : initCallback();
};

export const sentryEnhancer = createReduxEnhancer();

export { withErrorBoundary, ErrorBoundary };
